import dayjs from "dayjs";

export const Frequency = {
    "FrequencyEnum.daily": "daily",
    "FrequencyEnum.weekly": 'weekly'
}
export const getOptionsFrequencySelect = (lng) => {
    return [
        {
            id: 0,
            value: "FrequencyEnum.daily",
            label: lng === 'ru' ? 'Раз в день' : 'Once a day on weekdays'
        },
        {
            id: 1,
            value: "FrequencyEnum.weekly",
            label: lng === 'ru' ? 'Раз в неделю' : 'Once a week'
        },
    ]
}
export const getOptionsLanguageSelect = (lng) => {
    return [
        {
            id: 0,
            value: 'vvv',
            label: 'EN'
        },
        {
            id: 1,
            value: 'bbb',
            label: lng === 'ru' ? 'Раз в неделю' : 'Once a week'
        },
    ]
}

export const getOptionsWeekDaysSelect = (lng) => {
    return [
        { id: 0, value: 0, label: lng === 'ru' ? 'Понедельник' : 'Monday' },
        { id: 1, value: 1, label: lng === 'ru' ? 'Вторник' : 'Tuesday' },
        { id: 2, value: 2, label: lng === 'ru' ? 'Среда' : 'Wednesday' },
        { id: 3, value: 3, label: lng === 'ru' ? 'Четверг' : 'Thursday' },
        { id: 4, value: 4, label: lng === 'ru' ? 'Пятница' : 'Friday' },
        { id: 5, value: 5, label: lng === 'ru' ? 'Суббота' : 'Saturday' },
        { id: 6, value: 6, label: lng === 'ru' ? 'Воскресенье' : 'Sunday' },
    ];
};

export const getOptionsTimeSelect = (lng) => {
    const times = [];

    for (let h = 0; h < 24; h++) {
        for (let m = 0; m < 60; m += 10) {
            const hour = h.toString().padStart(2, '0'); // Два знака, например 09 вместо 9
            const minute = m.toString().padStart(2, '0');
            const timeValue = `${hour}:${minute}`;

            times.push({
                id: times.length,
                value: timeValue,
                label: lng === 'ru' ? `${timeValue}` : `${timeValue}`,
            });
        }
    }

    return times;
};


export const getOptionsTimezonesSelect = () => {
    return [
        { id: 0, value: -720, label: '(UTC-12:00) Baker Island' },
        { id: 1, value: -660, label: '(UTC-11:00) American Samoa' },
        { id: 2, value: -600, label: '(UTC-10:00) Hawaii' },
        { id: 3, value: -570, label: '(UTC-09:30) Marquesas Islands' },
        { id: 4, value: -540, label: '(UTC-09:00) Alaska' },
        { id: 5, value: -480, label: '(UTC-08:00) Pacific Time (US & Canada)' },
        { id: 6, value: -420, label: '(UTC-07:00) Mountain Time (US & Canada)' },
        { id: 7, value: -360, label: '(UTC-06:00) Central Time (US & Canada)' },
        { id: 8, value: -300, label: '(UTC-05:00) Eastern Time (US & Canada)' },
        { id: 9, value: -240, label: '(UTC-04:00) Atlantic Time (Canada)' },
        { id: 10, value: -210, label: '(UTC-03:30) Newfoundland' },
        { id: 11, value: -180, label: '(UTC-03:00) Buenos Aires' },
        { id: 12, value: -120, label: '(UTC-02:00) South Georgia' },
        { id: 13, value: -60, label: '(UTC-01:00) Azores' },
        { id: 14, value: 0, label: '(UTC+00:00) London, Lisbon' },
        { id: 15, value: 60, label: '(UTC+01:00) Paris, Berlin' },
        { id: 16, value: 120, label: '(UTC+02:00) Kyiv, Athens' },
        { id: 17, value: 180, label: '(UTC+03:00) Moscow, Istanbul' },
        { id: 18, value: 210, label: '(UTC+03:30) Tehran' },
        { id: 19, value: 240, label: '(UTC+04:00) Dubai' },
        { id: 20, value: 270, label: '(UTC+04:30) Kabul' },
        { id: 21, value: 300, label: '(UTC+05:00) Karachi' },
        { id: 22, value: 330, label: '(UTC+05:30) New Delhi' },
        { id: 23, value: 345, label: '(UTC+05:45) Kathmandu' },
        { id: 24, value: 360, label: '(UTC+06:00) Dhaka' },
        { id: 25, value: 390, label: '(UTC+06:30) Yangon' },
        { id: 26, value: 420, label: '(UTC+07:00) Bangkok, Jakarta' },
        { id: 27, value: 480, label: '(UTC+08:00) Beijing, Singapore' },
        { id: 28, value: 540, label: '(UTC+09:00) Tokyo, Seoul' },
        { id: 29, value: 570, label: '(UTC+09:30) Adelaide' },
        { id: 30, value: 600, label: '(UTC+10:00) Sydney' },
        { id: 31, value: 660, label: '(UTC+11:00) Solomon Islands' },
        { id: 32, value: 720, label: '(UTC+12:00) Auckland' },
        { id: 33, value: 780, label: '(UTC+13:00) Samoa' },
        { id: 34, value: 840, label: '(UTC+14:00) Kiritimati' },
    ];
};


export const TRIGGER_TYPE = {
    ON_VIDEO_PROCESS: "TriggerEnum.on_video_process",
    ON_SCHEDULE: "TriggerEnum.on_schedule",
}

export const getWeekdayFromDate = (dateString, lng) => {
    const date = dayjs(dateString);

    // day() в dayjs: 0 — Sunday, 1 — Monday, ..., 6 — Saturday
    // Твой массив начинается с ПОНЕДЕЛЬНИКА => смещаем: 1 (Mon) -> 0, 2 (Tue) -> 1, ..., 0 (Sun) -> 6
    const jsDay = date.day(); // возвращает 0 (вс) - 6 (сб)
    const mappedDay = jsDay === 0 ? 6 : jsDay - 1;

    const options = getOptionsWeekDaysSelect(lng);
    return options.find((day) => day.id === mappedDay)?.value;
};


export const getNextWeekdayDate = (
    weekdayId,             // 0 = Monday, ..., 6 = Sunday
    baseDate= dayjs(), // по умолчанию текущее время
) => {
    const currentDate = dayjs(baseDate);
    const currentWeekday = currentDate.day() === 0 ? 6 : currentDate.day() - 1;

    const daysToAdd =
        weekdayId >= currentWeekday
            ? weekdayId - currentWeekday
            : 7 - (currentWeekday - weekdayId);

    const targetDate = currentDate.add(daysToAdd, 'day');

    return targetDate;
};


export const findTimeValue = (
        date
) => {
    const targetTime = dayjs(date);
    // Преобразуем массив в [{ value, minutesFromMidnight }]
    const optionsWithMinutes = getOptionsTimeSelect('en').map((option) => {
        const [hours, minutes] = option.value.split(':').map(Number);
        return {
            ...option,
            minutesFromMidnight: hours * 60 + minutes,
        };
    });

    const targetMinutes = targetTime.hour() * 60 + targetTime.minute();

    // Найдём все, которые меньше или равны целевому времени
    const validOptions = optionsWithMinutes
        .filter((opt) => opt.minutesFromMidnight <= targetMinutes)
        .sort((a, b) => b.minutesFromMidnight - a.minutesFromMidnight); // сортировка по убыванию

    return validOptions.length > 0 ? validOptions[0].value : undefined;
};

export const getNextTimeDate = (
    time,                  // формат 'HH:mm'
    baseDate = dayjs(), // по умолчанию текущее время
) => {
    const [hourStr, minuteStr] = time.split(':');
    const hour = parseInt(hourStr, 10);
    const minute = parseInt(minuteStr, 10);

    const currentDate = dayjs(baseDate);

    const targetDate = currentDate.set('hour', hour).set('minute', minute).set('second', 0).set('millisecond', 0);

    return targetDate;
};

export const applyTimezoneOffset = (date, timezoneOffset) => {
    return dayjs.utc(date).utcOffset(timezoneOffset);
};

export const getTimezone = (value) => {
    console.log('vvvv',value)
    return getOptionsTimezonesSelect().find((item) => item.value === value)?.value || getOptionsTimezonesSelect()[14].value
}